import Upload from '@roo/roo/Upload'
import React, { FC, PropsWithChildren } from 'react'
import type { FileModel } from '@roo/roo/Upload'
import type { UploadOption } from '@roo/roo/_utils/Upload'
import { useTranslation } from '@sailor/i18n-web'
import styles from './styles.module.css'
import { Button, Tooltip } from '@roo/roo'
import { downloadFile } from '@/common/utils'

interface Props {
  onUpload: (file: Blob | null) => void,
  fileList:{name: string, fileS3Url?: string}[],
  setFileList: (fileList: Props['fileList']) => void
  disableDelete?: boolean;
}

const UploadIcon = (props: React.SVGProps<any>) => (
  <svg
    viewBox="0 0 1024 1024"
    width="64"
    height="64"
    {...props}
  // eslint-disable-next-line max-len
  ><path d="M938.3 530.8l-0.3-4.2c-0.2-2.9-0.4-5.7-0.7-8.6l-0.6-4.8c-0.3-2.6-0.6-5.2-1-7.8-0.2-1.6-0.5-3.2-0.8-4.9-0.4-2.6-0.9-5.1-1.4-7.7-0.3-1.6-0.6-3.1-1-4.7-0.6-2.6-1.2-5.2-1.8-7.7-0.4-1.5-0.7-2.9-1.1-4.3-0.7-2.7-1.5-5.4-2.3-8.1-0.4-1.2-0.8-2.5-1.1-3.7-0.9-2.9-1.9-5.9-3-8.8-0.3-0.9-0.7-1.9-1-2.8-1.3-3.4-2.6-6.8-4-10.2-0.2-0.4-0.3-0.7-0.4-1.1-28.1-66.3-82.8-118.8-151-143.9-0.4-0.1-0.7-0.3-1.1-0.4-3.4-1.2-6.9-2.4-10.4-3.5-0.8-0.2-1.5-0.5-2.3-0.7l-9.3-2.7-3.3-0.9c-2.8-0.7-5.7-1.4-8.5-2l-4.2-0.9c-2.6-0.5-5.2-1-7.8-1.4-1.6-0.3-3.3-0.6-4.9-0.8-0.4-0.1-0.8-0.1-1.2-0.2-57.1-67.9-142.3-108-231.8-108-145.2 0-268.7 102.7-296.9 242.6C126 457.1 89 523.9 89 595.4 89 711.5 183.5 806 299.6 806h162.2c-0.5-3.2-0.9-6.4-0.9-9.8V567.8l-63.7 63.7c-22.9 22.9-60.1 22.9-83 0s-22.9-60.1 0-83l163.9-163.9c22.9-22.9 60.1-22.9 83 0L725 548.5c22.9 22.9 22.9 60.1 0 83-11.5 11.5-26.5 17.2-41.5 17.2s-30-5.7-41.5-17.2l-63.7-63.7v228.4c0 3.3-0.3 6.6-0.9 9.8h99c144.6 0 262.2-117.6 262.2-262.2 0.1-4.4 0-8.7-0.3-13z" />
  </svg>
)


const UploadExcel:FC = (props:PropsWithChildren<Props>) => {
  const { fileList, setFileList } = props
  const { t } = useTranslation()
  const fileName = fileList[0]?.name
  const fileS3Url = fileList[0]?.fileS3Url

  return (
    <div>
      {
        fileName
          ? (
            <div style={{ display: 'flex', alignItems: 'center', color: '#FF5500', minWidth: 0 }}>
              <Tooltip content={fileName} placement="top">
                <div style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{fileName}</div>
              </Tooltip>
              {!props.disableDelete && (
                <>
                  &ensp;&ensp;
                  <Button type="text" onClick={() => {setFileList([])}} style={{ flexShrink: 0 }}>
                    <div style={{ color: '#FF5500', lineHeight: '22px', minWidth: 'min-content' }}>{t('e_pc_delete_record', '删除')}</div>
                  </Button>
                </>
              )}
              {fileS3Url && (
                <>
                 &ensp;&ensp;
                  <Button type="text" onClick={() => downloadFile({ url: fileS3Url })} style={{ flexShrink: 0 }}>
                    <div style={{ color: '#FF5500', lineHeight: '22px', minWidth: 'min-content' }}>{t('e_pc_file_download', '下载文件')}</div>
                  </Button>
                </>
              )
              }
            </div>
          )
          : (
            <Upload
              canDrop
              listType="text"
              showUploadList={false}
              fileList={fileList}
              name="file1"
              onChange={(_file: FileModel, updatedFileList: FileModel[]) => {setFileList(updatedFileList)}}
              customRequest={(options:UploadOption) => props.onUpload(options.file as File)}
              accept=".xlsx, .xls"
              maxCount={1}
            >
              <div className={styles.uploadContainer}>
                <UploadIcon className={styles.uploadIcon} />
                <div className={styles.uploadTitle}>{t('e_pc_upload_area', '请点击或拖拽文件至此上传')}</div>
                <div className={styles.uploadDesc}>{t('e_pc_file_format', '支持 xls, xlsx 格式的文件')}</div>
                <div className={styles.buttonContainer} onClick={e => e.stopPropagation()}>
                  {props.children}
                </div>
              </div>
            </Upload>
          )
      }

    </div>
  )
}

export default UploadExcel